export const autoCompleteDataLocator = {
    searchBarCross_CTA: 'homePage_searchBarCross_CTA',
    searchBarIcon_CTA: 'homePage_searchBarIcon_CTA',
    searchBar_inputField: 'homePage_searchBar_inputField'
};
